import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { WorkPackageWrapper } from './WorkPackageWrapper';

export const PhaseWrapper = ({ phase, project, onDeselect }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [hasWP, setHasWP] = useState(false);

  function checkPhaseForActiveWorkPackages(phase) {
    var hasPackages = false;
    if (phase.workPackages.length > 0) {
      phase.workPackages.forEach((element) => {
        if (
          Boolean(element.status === 0 || element.status === 2) &&
          Boolean(element.isTimeTrackable)
        )
          hasPackages = true;
      });
    }
    setHasWP(hasPackages);
  }

  useEffect(() => {
    checkPhaseForActiveWorkPackages(phase);
  }, [phase]);
  if (!hasWP) return;
  return (
    <Box className="rounded-lg px-2 py-1">
      <Typography variant="h4" className=" pb-4">
        {phase.name}
      </Typography>
      <Box className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6">
        {phase.workPackages.map(
          (workPackage) =>
            Boolean(workPackage.status === 0 || workPackage.status === 2) &&
            Boolean(workPackage.isTimeTrackable) && (
              <WorkPackageWrapper
                key={workPackage.id}
                workPackage={workPackage}
                project={project}
                onDeselect={onDeselect}
              />
            )
        )}
      </Box>
    </Box>
  );
};
